module.exports = __webpack_public_path__ + "img/newlogo.b945fa99.webp";